<template>
  <v-tabs
    v-model="tab"
    class="elevation-2"
    dark
  >
    <v-tabs-slider></v-tabs-slider>
    <v-tab href="#controller-tab">Controller</v-tab>
    <v-tab href="#misc-tab">Misc</v-tab>
    <v-tab href="#communication-tab">Communication</v-tab>
    <v-tab href="#debug-tab">Debug</v-tab>

    <v-tab-item eager value="controller-tab">
      <v-container class="rs-container" fluid fill-height>
        <div ref="container" class="rs-controller" tabindex="0" @keydown="onKeyDown" @keyup="onKeyUp" @mousedown="onMouseDown" @mouseup="onMouseUp" @touchstart="onTouchStart" @touchend="onTouchEnd" @touchcancel="onTouchCancel">
          <!-- <Led
            :bridge="bridge"
            width="330" height="330"
            left="590"
            top="100"
            :led="leds[0]"
          /> -->
          <div class="rs-background"></div>
          <div class="rs-display">
            <Display ref="display" type="NT7538" :bridge="bridge" :displayBuffer="displayBuffer" />
          </div>
          <v-container class="rs-controls">
            <v-row dense>
              <v-col cols="12" v-for="(button, index) in buttons" :key="`button-${index}`">
                <SensorButton
                  v-model="button.value"
                  :conversion="button.conversion"
                  :name="button.name"
                  :initialValue="button.initialValue"
                  @input="onSensorInput(button, button.platformIndex == null ? index : button.platformIndex, $event)"
                />
              </v-col>
            </v-row>
            <v-row dense>
              <v-col cols="6" v-for="(output, index) in outputs" :key="`output-${index}`">
                <Output
                  :value="output.value"
                  :conversion="output.conversion"
                  :name="output.name"
                />
              </v-col>
            </v-row>
          </v-container>
          <!-- <canvas width="857" height="708" style="position: absolute; left: 0; top: 0" ref="debugCanvas"></canvas> -->
        </div>
      </v-container>
    </v-tab-item>
    <v-tab-item eager value="misc-tab">
      <v-container>
        <v-row>
          <v-col>
            <LanguageSelect
              ref="languageSelect"
              title="Regler-Sprache"
              :bridge="bridge"
              :languages="languages"
              :localStoragePrefix="localStoragePrefix"
            />
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <LanguageSelect
              title="Screenshot-Sprache"
              ref="screenshotLanguageSelect"
              :languages="languages"
              :localStoragePrefix="localStoragePrefix"
              />
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <v-switch
              v-model="drawBorderAroundScreenshot"
              label="Draw border around screenshot"
            ></v-switch>
            <v-btn
              @click="saveScreenshot()"
            >
              Save screenshot
            </v-btn>
            <v-btn
              @click="saveScreenshots()"
            >
              Save screenshots in all languages
            </v-btn>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <v-btn
              @click="reset()"
            >
              Reset
            </v-btn>
            <v-btn
              @click="exportStorage()"
            >
              Export Storage
            </v-btn>
            <v-btn
              @click="$refs.storageFileInput.click()"
            >
              Import Storage &amp; Reset
            </v-btn>
            <v-btn
              @click="eraseStorage()"
            >
              Erase Storage &amp; Reset
            </v-btn>
            <input
              ref="storageFileInput"
              type="file"
              style="display: none"
              @change="onStorageFileInputChanged"
            >
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <SDCard
              :bridge="bridge"
            />

          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <LogPanel :logLines="logLines" />
          </v-col>
          <v-col cols="6">
          </v-col>
        </v-row>
      </v-container>
    </v-tab-item>
    <v-tab-item eager value="communication-tab">
      <CommPanel
        ref="communication"
        :uarts="uarts"
        :bridge="bridge"
        :vbusSpecifications="vbusSpecifications"
      />
    </v-tab-item>
    <v-tab-item eager value="debug-tab">
      <v-container fluid>
        <v-row>
          <v-col cols="6">
            <v-treeview
              :items="debugItems"
              dense
            ></v-treeview>
          </v-col>
          <v-col cols="6">
            <v-btn @click="bridge.start()">Start</v-btn>
            <v-btn @click="bridge.stop()">Stop</v-btn>
            <v-btn @click="generateSupportReport">Generate support report</v-btn>
            <v-textarea
              auto-grow
              dense
              readonly
              :value="supportReportText"
              class="rs-support-report"
            ></v-textarea>
          </v-col>
        </v-row>
      </v-container>
    </v-tab-item>
  </v-tabs>
</template>

<script>
import SensorButton from '@/components/SensorButton';
import LanguageSelect from '@/components/LanguageSelect';
import SDCard from '@/components/SDCard';
import Output from '@/components/Output';
import LogPanel from '@/components/LogPanel';
import CommPanel from '@/components/communication/CommPanel';
// import Led from '@/components/Led';
import Display from '@/components/Display';
import Uart from '@/mixins/Uart';
import Bridgeable from '@/mixins/Bridgeable';
import Screenshotable from '@/mixins/Screenshotable';

import state from '@/state';
import { startDownload, readFile, sleep } from '@/utils';

export default {
  props: [
    'localStoragePrefix',
    'buttons',
    'outputs',
    'leds',
    'uarts',
    'languages',
    'bridge',
    'vbusSpecifications',
  ],

  data: () => ({
    logLines: [],
    buttonRefs: null,
    outputRefs: null,
    lastMouseButtonType: 0,
    activeTouches: [],
    tab: null,
    debugItems: [],
    supportReportText: '',
    drawBorderAroundScreenshot: false,
    displayBuffer: null,

    key_table :
      [
        // { button: 'ArrowLeft' , index: 1, x: 195, y: 393, w: 64, h: 64 },
        // { button: 'ArrowRight', index: 2, x: 459, y: 393, w: 64, h: 64 },
        // { button: 'ArrowUp'   , index: 3, x: 480, y:  75, w: 64, h: 64 },
        // { button: 'ArrowDown' , index: 4, x: 480, y: 217, w: 64, h: 64 },

        { button: 'Enter'     , index: 5, x: 532, y: 485, w: 114, h: 36 }, // DONE
        { button: 'Backspace' , index: 6, x: 210, y:  485, w: 114, h: 36 }, // DONE
        // { button: '#'         , index: 7, x: 402, y: 220, w: 40, h: 40 },
        { button: 'func2', index: 7, x: 70, y: 635, w: 36, h: 36 },
        { button: 'func3', index: 8, x: 150, y: 635, w: 36, h: 36 },
        { button: 'Clockwise', index: 10, x: 428, y: 442, w: 100, h: 200 },
        { button: 'CounterCw', index: 11, x: 328, y: 442, w: 100, h: 200 },
        // vim key-bindings ;-)
        { button: 'h' , index: 6 },
        { button: 'l' , index: 5 },
        { button: 'k' , index: 11 },
        { button: 'j' , index: 10 },
      ],
    key_number_state: false,
    keyQueue: [],
    keyButtonPressedIsActive: false,
  }),

  components: {
    Display,
    // Led,
    SensorButton,
    Output,
    LanguageSelect,
    SDCard,
    LogPanel,
    CommPanel,
  },

  mixins: [
    Bridgeable,
    Screenshotable,
    Uart,
  ],

  mounted() {
    // const cnv = this.$refs.debugCanvas;
    // const ctx = cnv.getContext('2d');
    // ctx.fillStyle = '#ff000040';
    // ctx.fillRect(210, 485, 114, 36);  // ESC
    // ctx.fillRect(532, 485, 114, 36);  // OK
    // ctx.fillRect(328, 442, 200, 200); // Lightwheel
    // ctx.fillRect(70, 635, 36, 36);    // Func1
    // ctx.fillRect(150, 635, 36, 36);   // Func2
  },

  destroyed() {
  },

  methods: {
    preparePlatform() {
      this.debugItems = this.bridge.debugProbes;

      for (let index = 0; index < this.buttons.length; index++) {
        this.onSensorInput(this.buttons [index], index, this.buttons [index].value);
      }

      this.$refs.container.focus();

      this.buttonRefs = this.buttons.reduce((memo, button) => {
        if (button.ref) {
          memo [button.ref] = button;
        }
        return memo;
      }, {});

      this.outputRefs = this.outputs.reduce((memo, output) => {
        if (output.ref) {
          memo [output.ref] = output;
        }
        return memo;
      }, {});

      this.initializeCommunication();

      this.$emit('initialized');
    },

    onKeyDown(ev) {
      this.onKeyEvent(ev, true);
    },

    onKeyUp(ev) {
      this.onKeyEvent(ev, false);
    },

    onKeyEvent(ev, state) {
      let b = this.key_table.find(b => b.button == ev.key);
      if(  ( (ev.key >= '0') && (ev.key <= '9') ) && state /* && !this.key_number_state */ ) {
        let k ;
        k = +ev.key;
        this.keyQueue.push(k);
        this.postKeyButtonPressedIfIdle();

        ev.preventDefault();
        ev.stopPropagation();
      }
      this.key_number_state = state;
      if(!b) return;
      ev.preventDefault();
      ev.stopPropagation();
      this.bridge.setButtonState(b.index, state);
    },

    postKeyButtonPressedIfIdle() {
      if (!this.keyButtonPressedIsActive) {
        this.keyButtonPressedIsActive = true;

        const TIME_KEYPRESS = 50; //  50;


        const press = async  (key, n=1) => {
          for(let i = 0; i < n;i++) {
            this.bridge.setButtonState(key, true);
            await sleep(TIME_KEYPRESS);
            this.bridge.setButtonState(key, false);
            await sleep(TIME_KEYPRESS);
          }
        };

        const digit = async (digit, ok=true) => {
          if(digit < 6) {
            await press(10, digit);
          } else {
            await press(11, 10 - digit);
          }

          if (ok) {
            await press(5);
          }
        };

        const runner = async () => {
          try {
            while (this.keyQueue.length > 0) {
              const key = this.keyQueue.shift();

              if (key >= 0 && key <= 9) {
                  await digit(key);
                  // return; on return, keys that arrive while waiting are ignored
              }
            }
          } finally {
            this.keyButtonPressedIsActive = false;
          }
        };

        runner();
        // runner().then(null, err => { console.error(err); });
      }
    },

    getButtonTypeByCoord(x, y) {
      const inRange = (x, min, max) => (x > min-1) && (x < max+1);
      const inRect  = (p, r) => inRange(p.x, r.x, r.x+r.w) && inRange(p.y, r.y, r.y+r.h);

      const b = this.key_table.find(b => b.w && b.h && inRect({x,y},b));
      return b ? b.index : 0;
    },
    // getButtonTypeByCoord(x, y) {
    //   const coords = {
    //     x,
    //     y,
    //   };

    //   function checkCoords(x, y, w, h) {
    //     let result;
    //     if (coords.x < x) {
    //       result = false;
    //     } else if (coords.x >= (x + w)) {
    //       result = false;
    //     } else if (coords.y < y) {
    //       result = false;
    //     } else if (coords.y >= (y + h)) {
    //       result = false;
    //     } else {
    //       result = true;
    //     }
    //     return result;
    //   }

    //   let buttonType;
    //   if (checkCoords(210, 485, 114, 36)) {
    //     buttonType = 6;  // ESC
    //   } else if (checkCoords(532, 485, 114, 36)) {
    //     buttonType = 5;  // OK
    //   } else if (checkCoords(328, 442, 100, 200)) {
    //     buttonType = 11;
    //   } else if (checkCoords(428, 442, 100, 200)) {
    //     buttonType = 10;
    //   } else if (checkCoords(70, 635, 36, 36)) {
    //     buttonType = 7;
    //   } else if (checkCoords(150, 635, 36, 36)) {
    //     buttonType = 8;
    //   }

    //   return buttonType;
    // },

    // onMouseDown(ev) {
    //   if (this.lastMouseButtonType) {
    //     this.onMouseEvent(ev, false);

    //     this.lastMouseButtonType = 0;
    //   }

    //   const buttonType = this.getButtonTypeByCoord(ev.offsetX, ev.offsetY);
    //   this.lastMouseButtonType = buttonType;

    //   this.onMouseEvent(ev, true);
    // },

    // onMouseUp(ev) {
    //   this.onMouseEvent(ev, false);

    //   this.lastMouseButtonType = 0;
    // },

    // onMouseEvent(ev, state) {
    //   const buttonType = this.lastMouseButtonType;

    //   if (buttonType > 0) {
    //     ev.preventDefault();
    //     ev.stopPropagation();

    //     this.bridge.setButtonState(buttonType, state);
    //   }
    // },
    onMouseDown(ev) {
      this.onMouseEvent(ev, false);
      this.lastMouseButtonType = this.getButtonTypeByCoord(ev.offsetX, ev.offsetY);
      this.onMouseEvent(ev, true);
    },

    onMouseUp(ev) {
      this.onMouseEvent(ev, false);
      this.lastMouseButtonType = 0;
    },

    onMouseEvent(ev, state) {
      const buttonType = this.lastMouseButtonType;

      if (buttonType) {
        ev.preventDefault();
        ev.stopPropagation();
        this.bridge.setButtonState(buttonType, state);
      }
    },

    onTouchStart(ev) {
      this.onTouchEvent(ev, true);
    },

    onTouchEnd(ev) {
      this.onTouchEvent(ev, false);
    },

    onTouchCancel(ev) {
      this.onTouchEvent(ev, false);
    },

    onTouchEvent(ev) {
      let stopEvent = false;

      const activeTouches = [];
      for (let index = 0; index < ev.touches.length; index++) {
        const touch = ev.touches.item(index);

        let touchInfo = this.activeTouches.find(info => info.identifier === touch.identifier);
        if (!touchInfo) {
          const rect = touch.target.getBoundingClientRect();

          const x = touch.clientX - rect.x;
          const y = touch.clientY - rect.y;


          const buttonType = this.getButtonTypeByCoord(x, y);

          if (buttonType) {
            this.bridge.setButtonState(buttonType, true);
            stopEvent = true;
          }

          touchInfo = {
            identifier: touch.identifier,
            buttonType,
            x,
            y,
          };
        }

        activeTouches.push(touchInfo);
      }

      for (const touchInfo of this.activeTouches) {
        if (!activeTouches.includes(touchInfo)) {
          if (touchInfo.buttonType) {
            this.bridge.setButtonState(touchInfo.buttonType, false);
            stopEvent = true;
          }
        }
      }

      if (stopEvent) {
        ev.preventDefault();
        ev.stopPropagation();
      }

      this.activeTouches = activeTouches;
    },

    handleInterval() {
      if (this.bridge.isDisplayInvalidated()) {
        this.displayBuffer = this.bridge.getDisplayBuffer().slice();
      }

      if (this.bridge.isLedInvalidated()) {
          const ColorShiftOff = 0;
          const ColorShiftRed = 8;
          const ColorShiftGreen = 12;
          const ColorShiftOrange = 16;

          for (let index = 0; index < 1; index++) {
            if (!this.leds [index]) {
              continue;
            }
            const state = this.bridge.getLedStaticState(index);

            this.leds [index].state = state;
            this.leds [index].TimerColor0 = ((state >> ColorShiftOff) & 15) * 25;
            this.leds [index].TimerColor1 = ((state >> ColorShiftRed) & 15) * 25;
            this.leds [index].TimerColor2 = ((state >> ColorShiftGreen) & 15) * 25;
            this.leds [index].TimerColor3 = ((state >> ColorShiftOrange) & 15) * 25;
          }
      }

      if (this.bridge.isOutputInvalidated()) {
        for (let index = 0; index < 19; index++) {
          if (!this.outputs [index]) {
            continue;
          }
          const value = this.bridge.getOutputValueAndType(index);
          this.outputs [index].value = value;
        }
      }
    },

    onSensorInput(button, index, value) {
      // Error.stackTraceLimit = Infinity;
      // console.log(index, button.name, button.value, value, new Error().stack);
      if (!this.bridge || !value) {
        // nop
      } else {
        this.bridge.setInputValueForType(index, value.type, value.value);
      }
    },

    async generateSupportReport() {
      const jsonString = JSON.stringify(this.debugItems);
      const jsonBuffer = Buffer.from(jsonString);
      const b64String = jsonBuffer.toString('base64');
      const lines = b64String.replace(/(.{76})/g, '$1\n').trim();
      const report = `----BEGIN WASI CONTROLLER TRAINER SUPPORT REPORT----\n${lines}\n----END WASI CONTROLLER TRAINER SUPPORT REPORT----\n`;
      this.supportReportText = report;

      await navigator.clipboard.writeText(report);
    },

    exportStorage() {
      startDownload(`storage-${Date.now()}.cbor`, 'application/octet-stream', this.storage);
    },

    onStorageFileInputChanged() {
      state.runAsync(async () => {
        const buffer = await readFile(this.$refs.storageFileInput);

        this.storage = buffer;
        this.reset();
      });
    },

    eraseStorage() {
      this.storage = null;

      const storageLsKey = `${this.localStoragePrefix}Storage`;
      localStorage.removeItem(storageLsKey);

      this.reset();
    },
  },
};
</script>

<style scoped>
.rs-container {
  padding: 0;
}

.rs-controller {
  width: 1024px;
  height: 708px;
  margin-left: auto;
  margin-right: auto;
  position: relative;
}

.rs-background {
  width: 857px;
  height: 708px;
  position: absolute;
  background: url('/DeviceSl_ResolDeltaSolSl.png');
  background-size: 857px 708px;
}

.rs-display {
  position: absolute;
  width: 570px;
  height: 285px;
  left: 142px;
  top: 130px;
}

.rs-controls {
  position: absolute;
  left: 860px;
  top: 0px;
  width: 160px;
  height: 708px;
  max-width: 160px;
}

.rs-support-report {
  font-family: 'Courier New', Courier, monospace;
  font-size: 10px;
}

.rs-support-report >>> textarea {
  line-height: 12px;
}
</style>
